/* Maison Noor — drobna warstwa interakcji motywu.
   Bez JS strona działa: to tylko sterowanie wideo i wejścia sekcji. */
(function () {
  "use strict";

  var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- przyciski pauzy przy wideo ---------- */
  function wireVideos(root) {
    (root || document).querySelectorAll("[data-mn-pause]").forEach(function (btn) {
      if (btn.dataset.mnReady) return;
      btn.dataset.mnReady = "1";
      var v = document.getElementById(btn.getAttribute("data-mn-pause"));
      if (!v) return;

      function mark(playing) {
        btn.classList.toggle("paused", !playing);
        btn.setAttribute("aria-label", playing ? "Video pauzeren" : "Video afspelen");
      }

      if (still) { v.pause(); mark(false); }
      else { var k = v.play(); if (k && k.catch) k.catch(function () { mark(false); }); mark(true); }

      btn.addEventListener("click", function () {
        if (v.paused) { v.play(); mark(true); } else { v.pause(); mark(false); }
      });
    });
  }

  /* ---------- delikatne wejście sekcji ---------- */
  function wireReveal(root) {
    var els = (root || document).querySelectorAll(".mn-rv:not(.in)");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(root) { wireVideos(root); wireReveal(root); }

  document.addEventListener("DOMContentLoaded", function () { init(document); });

  /* Edytor motywu przeładowuje pojedyncze sekcje — trzeba je podpiąć na nowo,
     inaczej po zmianie ustawienia wideo przestaje działać w podglądzie. */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();

/* ---------- kroki „Navullen" sterowane scrollem + siatka bezpieczeństwa dla wejść ----------
   Przeniesione z landingu. Kluczowa lekcja stamtąd: postęp mierzymy względem CAŁEJ
   sekcji, nie samego rzędu kroków — rząd ma ~200 px, więc licznik saturował się
   natychmiast i animacja przeskakiwała 0→100%. */
(function () {
  "use strict";
  var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function scrub() {
    document.querySelectorAll("[data-mn-steps]").forEach(function (steps) {
      var sec = steps.closest(".mn-sec") || steps.parentNode;
      var items = steps.querySelectorAll("li");
      if (!items.length) return;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh - r.top) / (vh * 0.55);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      steps.style.setProperty("--stepW", (p * 100).toFixed(1) + "%");
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle("on", p >= (i + 0.55) / items.length * 0.9);
      }
    });
  }

  /* Observer potrafi pominąć blok przy szybkim scrollu — to jest ta siatka. */
  function catchUp() {
    var vh = window.innerHeight;
    document.querySelectorAll(".mn-rv:not(.in)").forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.94) el.classList.add("in");
    });
  }

  var tick = false;
  function onScroll() {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () { if (!still) scrub(); catchUp(); tick = false; });
  }

  function start() {
    if (still) { document.querySelectorAll("[data-mn-steps] li").forEach(function (li) { li.classList.add("on"); }); }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  document.addEventListener("DOMContentLoaded", start);
  document.addEventListener("shopify:section:load", onScroll);
})();

/* ---------- strona produktu: warianty + galeria ze zbliżeniem ----------
   Bez JS strona nadal działa: select wysyła poprawne id wariantu, a zdjęcia
   są zwykłymi obrazkami. JS dokłada tylko wygodę. */
(function () {
  "use strict";

  function wireVariants(root) {
    (root || document).querySelectorAll("[data-mn-variant]").forEach(function (sel) {
      if (sel.dataset.mnReady) return;
      sel.dataset.mnReady = "1";
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        var scope = sel.closest(".mn-prod, .mn-sec");
        var out = scope.querySelector("[data-mn-price]");
      if (out && opt && opt.dataset.price) {
        var price = Number(opt.dataset.priceRaw);
        var compare = Number(opt.dataset.compareRaw);

        out.textContent = "";

        if (compare > price) {
          var oldPrice = document.createElement("s");
          oldPrice.style.opacity = "0.65";
          oldPrice.textContent = opt.dataset.comparePrice;

          var currentPrice = document.createElement("strong");
          currentPrice.textContent = opt.dataset.price;

          var discount = document.createElement("span");
          discount.style.color = "#b08d6b";
          discount.style.fontSize = "14px";
          discount.style.fontWeight = "700";
          discount.textContent =
            "−" + Math.round((compare - price) / compare * 100) + "%";

          out.appendChild(oldPrice);
          out.appendChild(currentPrice);
          out.appendChild(discount);
        } else {
          out.textContent = opt.dataset.price;
        }
      }

        /* wariant z własnym zdjęciem przełącza galerię — bez tego klient wybiera
           500 ml, a widzi zdjęcie setki */
        var g = scope.querySelector("[data-mn-gallery]");
        if (g && g.mnShow && opt && opt.dataset.media) g.mnShow(opt.dataset.media);
      });
    });
  }

  function wireGallery(root) {
    (root || document).querySelectorAll("[data-mn-gallery]").forEach(function (g) {
      if (g.dataset.mnReady) return;
      g.dataset.mnReady = "1";

      function show(id) {
        if (!id) return;
        g.querySelectorAll("[data-mn-media]").forEach(function (it) {
          var on = it.getAttribute("data-mn-media") === String(id);
          it.classList.toggle("is-on", on);
          /* wideo poza kadrem ma się zatrzymać, żeby nie grało w tle */
          if (!on) { var v = it.querySelector("video"); if (v && !v.paused) v.pause(); }
        });
        g.querySelectorAll("[data-mn-thumb]").forEach(function (t) {
          t.classList.toggle("is-on", t.getAttribute("data-media") === String(id));
        });
        /* Kadr 4:5 jest pod zdjęcia produktowe; wideo jest poziome i dostawało
           czarne pasy. Przy wideo przełączamy proporcje kadru na 16:9. */
        var stage = g.querySelector(".mn-prod__stage");
        var on = g.querySelector("[data-mn-media].is-on");
        if (stage) stage.classList.toggle("has-video", !!(on && on.querySelector("video, iframe")));
      }
      g.mnShow = show;

      g.querySelectorAll("[data-mn-thumb]").forEach(function (t) {
        t.addEventListener("click", function () { show(t.getAttribute("data-media")); });
      });

      g.querySelectorAll("[data-mn-zoom]").forEach(function (z) {
        z.addEventListener("click", function () { openBox(g, z); });
      });
      var stage = g.querySelector(".mn-prod__stage");
if (stage) {
  var startX = null;
  var startY = null;
  var blockZoomUntil = 0;

  stage.addEventListener("touchstart", function (e) {
    if (!window.matchMedia("(max-width: 860px)").matches) return;
    if (!e.target.closest(".mn-prod__zoom")) return;
    startX = e.changedTouches[0].clientX;
    startY = e.changedTouches[0].clientY;
  }, { passive: true });

  stage.addEventListener("touchend", function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    startX = null;
    startY = null;

    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2) return;

    var photos = Array.prototype.slice.call(
      g.querySelectorAll("[data-mn-media]")
    ).filter(function (item) {
      return !!item.querySelector(".mn-prod__zoom");
    });
    if (photos.length < 2) return;

    var current = photos.findIndex(function (item) {
      return item.classList.contains("is-on");
    });
    if (current < 0) return;

    var next = (current + (dx < 0 ? 1 : -1) + photos.length) % photos.length;
    blockZoomUntil = Date.now() + 400;
    show(photos[next].getAttribute("data-mn-media"));
  }, { passive: true });

  stage.addEventListener("click", function (e) {
    if (Date.now() < blockZoomUntil) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}
  });
  }
  /* ---------- pełny ekran: przeglądanie zdjęć bez zamykania ----------
     Wcześniej powiększenie pokazywało JEDNO zdjęcie i żeby obejrzeć następne
     trzeba było wyjść i kliknąć kolejną miniaturę. Teraz lightbox trzyma listę
     zdjęć z tej galerii i chodzi po niej strzałkami, klawiszami ←/→ i gestem
     palca. Wideo zostaje w kadrze na stronie — na pełnym ekranie oglądamy
     wyłącznie zdjęcia. */
  var box = null, shots = [], at = 0, gal = null, touchX = null;

  function build() {
    box = document.createElement("div");
    box.className = "mn-lightbox";
    box.innerHTML =
      '<button class="mn-lightbox__x" type="button" aria-label="Sluiten">&times;</button>' +
      '<button class="mn-lightbox__nav mn-lightbox__nav--prev" type="button" aria-label="Vorige foto"></button>' +
      '<button class="mn-lightbox__nav mn-lightbox__nav--next" type="button" aria-label="Volgende foto"></button>' +
      '<figure class="mn-lightbox__frame"><img alt=""></figure>' +
      '<p class="mn-lightbox__count" aria-live="polite"><span data-mn-at>1</span> / <span data-mn-of>1</span></p>';
    document.body.appendChild(box);

    /* zamyka TYLKO kliknięcie w tło — nie w zdjęcie i nie w strzałkę */
    box.addEventListener("click", function (e) { if (e.target === box) closeBox(); });
    box.querySelector(".mn-lightbox__x").addEventListener("click", closeBox);
    box.querySelector(".mn-lightbox__nav--prev").addEventListener("click", function () { step(-1); });
    box.querySelector(".mn-lightbox__nav--next").addEventListener("click", function () { step(1); });

    document.addEventListener("keydown", function (e) {
      if (!box.classList.contains("is-on")) return;
      if (e.key === "Escape") closeBox();
      else if (e.key === "ArrowLeft") { e.preventDefault(); step(-1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); step(1); }
    });

    box.addEventListener("touchstart", function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    box.addEventListener("touchend", function (e) {
      if (touchX === null) return;
      var d = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(d) > 40) step(d < 0 ? 1 : -1);
    }, { passive: true });
  }

  function openBox(g, trigger) {
    if (!box) build();
    gal = g;
    shots = Array.prototype.slice.call(g.querySelectorAll("[data-mn-zoom] img"));
    at = Math.max(0, shots.indexOf(trigger.querySelector("img")));
    box.classList.toggle("is-single", shots.length < 2);
    box.querySelector("[data-mn-of]").textContent = shots.length;
    paint();
    box.classList.add("is-on");
    document.body.style.overflow = "hidden";
    (shots.length > 1 ? box.querySelector(".mn-lightbox__nav--next") : box.querySelector(".mn-lightbox__x")).focus();
  }

  function paint() {
    var cur = shots[at];
    if (!cur) return;
    var img = box.querySelector(".mn-lightbox__frame img");
    img.src = cur.dataset.full || cur.src;
    img.alt = cur.alt || "";
    box.querySelector("[data-mn-at]").textContent = at + 1;
    /* sąsiedzi wczytani w tle — przeskok bez mignięcia pustym kadrem */
    [shots[at - 1], shots[at + 1]].forEach(function (n) {
      if (n) { var p = new Image(); p.src = n.dataset.full || n.src; }
    });
  }

  function step(d) {
    if (shots.length < 2) return;
    at = (at + d + shots.length) % shots.length;
    paint();
  }

  function closeBox() {
    if (!box) return;
    box.classList.remove("is-on");
    document.body.style.overflow = "";
    /* kadr na stronie zostaje na tym zdjęciu, na którym skończyliśmy oglądać */
    var item = shots[at] && shots[at].closest("[data-mn-media]");
    if (gal && gal.mnShow && item) gal.mnShow(item.getAttribute("data-mn-media"));
  }

  function init(root) { wireVariants(root); wireGallery(root); }
  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();

/* ==========================================================================
   Onze merken — taśma, która jedzie sama, ale można ją złapać.
   Dwa zestawy kart w HTML (drugi to klony), więc po dojechaniu do połowy
   cofamy przewinięcie o dokładnie połowę i pętla nie ma szwu.
   ========================================================================== */
(function () {
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SPEED = 0.523;    /* px na klatkę, ok. 31 px/s. Droga: 0,35 → +30% = 0,455 → +15% = 0,523 */
  var RESUME = 2000;    /* ms bezczynności, zanim taśma znów ruszy sama */

  function wireRail(root) {
    (root || document).querySelectorAll("[data-mn-rail]").forEach(function (rail) {
      if (rail.dataset.mnRailOn) return;
      rail.dataset.mnRailOn = "1";

      var held = false, seen = false, idle = 0;

      function release() { held = false; rail.classList.remove("is-held"); }
      function hold() {
        held = true;
        rail.classList.add("is-held");   /* snap wraca, gdy steruje człowiek */
        clearTimeout(idle);
        idle = setTimeout(release, RESUME);
      }

      ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (ev) {
        rail.addEventListener(ev, hold, { passive: true });
      });

      /* ---- MYSZKA ----------------------------------------------------------
         Touchpad umie przesunąć w poziomie i przeglądarka sama przewija taśmę.
         Kółko myszy daje tylko deltaY — ta trafia do STRONY, nie do taśmy, więc
         użytkownik z myszką nie mógł ruszyć taśmy wcale (ani kółkiem, ani
         przeciągnięciem, bo natywne „drag to scroll" działa tylko dotykiem).
         Dodajemy trzy drogi i ŻADNA nie zabiera stronie pionowego scrolla:
           1. przeciąganie myszką (chwyt i pociągnij),
           2. Shift + kółko → w poziomie (konwencja przeglądarek),
           3. strzałki ‹ › w nagłówku sekcji (osobny blok niżej).
         Celowo NIE przechwytujemy zwykłego kółka: taśma jest zapętlona, więc
         zawsze ma „zapas" i strona przestałaby się przewijać, gdy kursor mija tę
         sekcję — to najczęstsza skarga na takie karuzele. */
      rail.addEventListener("wheel", function (e) {
        if (e.shiftKey && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          hold();
          rail.scrollLeft += e.deltaY;
        }
      }, { passive: false });

      /* ⚠ DLACZEGO TO NIE JEST ZWYKŁE `scrollLeft = start - dx`:
         (1) przy chwycie włączamy `is-held`, a ta klasa dodaje scroll-snap — przy ustawianiu
             scrollLeft na każdym ruchu przeglądarka DOCIĄGA do najbliższej karty i ruch „tnie";
             dlatego klasa `is-dragging` snap wyłącza (CSS).
         (2) bez pointer capture ruch gubi się, gdy kursor wyjedzie za taśmę.
         (3) touchpad ma wybieg z natury — myszka nie, więc po puszczeniu dokładamy inercję.
         Pozycję zmieniamy w JEDNYM miejscu (pętla `frame`), nie w obsłudze zdarzeń. */
      var drag = { gotowy: false, on: false, cel: 0, v: 0, ostatniX: 0, startX: 0, ruszyl: false };

      /* ⚠⚠ setPointerCapture NIE MOŻE być wołane na pointerdown. Z przejętym wskaźnikiem
         przeglądarka wysyła `click` do elementu przechwytującego (taśmy), a NIE do kafelka —
         i linki marek przestają działać całkowicie. Przechwytujemy dopiero, gdy ruch
         naprawdę się zaczął (próg 6 px); zwykłe kliknięcie nigdy tam nie dochodzi. */
      var PROG = 6;
      var blokujKlik = false, blokTimer = 0;

      rail.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) return;   /* dotyk ma natywne przewijanie */
        drag.gotowy = true; drag.on = false; drag.ruszyl = false; drag.v = 0;
        drag.cel = rail.scrollLeft; drag.ostatniX = e.clientX; drag.startX = e.clientX;
      });

      rail.addEventListener("pointermove", function (e) {
        if (!drag.gotowy) return;
        if (!drag.on) {
          if (Math.abs(e.clientX - drag.startX) < PROG) return;    /* to jeszcze klik, nie ciągnięcie */
          drag.on = true; drag.ruszyl = true;
          rail.classList.add("is-dragging");
          try { rail.setPointerCapture(e.pointerId); } catch (err) {}
          drag.ostatniX = drag.startX;
        }
        var dx = e.clientX - drag.ostatniX;
        drag.ostatniX = e.clientX;
        drag.cel -= dx;
        drag.v = drag.v * 0.6 + (-dx) * 0.4;                       /* wygładzona prędkość na wybieg */
        hold();
        e.preventDefault();
      });

      function koniecDrag(e) {
        if (!drag.gotowy) return;
        var bylRuch = drag.on;
        drag.gotowy = false; drag.on = false;
        if (bylRuch) {
          try { if (e && e.pointerId != null) rail.releasePointerCapture(e.pointerId); } catch (err) {}
          rail.classList.remove("is-dragging");
          if (Math.abs(drag.v) < 0.4) drag.v = 0;
          if (drag.v) rail.classList.add("is-coasting");            /* sam wybieg: snap off, linki żyją */
          /* blokada klika po przeciągnięciu wygasa SAMA po 250 ms — wcześniej wisiała
             do najbliższego kliknięcia i zjadała pierwszy klik w kartę. */
          blokujKlik = true;
          clearTimeout(blokTimer);
          blokTimer = setTimeout(function () { blokujKlik = false; }, 250);
        } else {
          drag.v = 0;                                               /* zwykły klik — zero wybiegu */
        }
      }
      ["pointerup", "pointercancel"].forEach(function (ev) {
        rail.addEventListener(ev, koniecDrag);
      });
      window.addEventListener("blur", function () { koniecDrag(null); });

      rail.addEventListener("click", function (e) {
        if (!blokujKlik) return;                                    /* normalny klik przechodzi do linku */
        blokujKlik = false;
        e.preventDefault(); e.stopPropagation();
      }, true);

      /* strzałki: szukamy ich w tej samej sekcji co taśma */
      var sekcja = rail.closest("section") || document;
      sekcja.querySelectorAll("[data-mn-rail-prev],[data-mn-rail-next]").forEach(function (b) {
        b.addEventListener("click", function () {
          var karta = rail.children[0];
          var krok = karta ? karta.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
          hold();
          rail.scrollBy({ left: b.hasAttribute("data-mn-rail-prev") ? -krok : krok, behavior: "smooth" });
        });
      });
      rail.addEventListener("mouseenter", function () { held = true; rail.classList.add("is-held"); });
      rail.addEventListener("mouseleave", function () { clearTimeout(idle); idle = setTimeout(release, 400); });

      /* przy wyłączonych animacjach taśma zostaje zwykłym przewijaniem palcem */
      if (still) { rail.classList.add("is-held"); return; }

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (es) { seen = es[0].isIntersecting; })
          .observe(rail);
      } else { seen = true; }

      /* UWAGA: pozycję trzymamy w zmiennej, a nie w scrollLeft. Przeglądarka zaokrągla
         scrollLeft do pełnych pikseli, więc "scrollLeft += 0.35" gubi się w zaokrągleniu
         i taśma stoi w miejscu. Sprawdzone — bez akumulatora nie rusza wcale. */
      var pos = 0;

      /* Szew liczymy z pozycji pierwszego klona, NIE z scrollWidth/2. Połowa szerokości
         wypada w środku odstępu między kartami i myli się o pół gapu (zmierzone: 12,5 px),
         co przy każdym okrążeniu widać jako szarpnięcie. */
      function seam() {
        var k = rail.children;
        if (k.length < 2) return 0;
        var n = Math.floor(k.length / 2);
        return k[n].offsetLeft - k[0].offsetLeft;
      }

      (function frame() {
        var loop = seam();
        if (loop > 0) {
          if (drag.on) {
            /* ciągnięcie myszką: pozycja z akumulatora, raz na klatkę — płynnie i bez snapu */
            if (drag.cel < 0) { drag.cel += loop; }
            if (drag.cel >= loop) { drag.cel -= loop; }
            rail.scrollLeft = drag.cel;
            pos = drag.cel;
          } else if (drag.v) {
            /* wybieg po puszczeniu — to samo wrażenie co na touchpadzie */
            drag.cel += drag.v;
            drag.v *= 0.93;
            if (Math.abs(drag.v) < 0.15) { drag.v = 0; rail.classList.remove("is-coasting"); }
            if (drag.cel < 0) drag.cel += loop;
            if (drag.cel >= loop) drag.cel -= loop;
            rail.scrollLeft = drag.cel;
            pos = drag.cel;
          } else if (held) {
            pos = rail.scrollLeft;          /* człowiek prowadzi — idziemy za nim */
          } else if (seen && rail.scrollWidth > rail.clientWidth + 4) {
            pos += SPEED;
            /* obie połówki mają tę samą treść, więc przeskok o szew jest niewidoczny */
            if (pos >= loop) pos -= loop;
            rail.scrollLeft = pos;
          }
        }
        requestAnimationFrame(frame);
      })();
    });
  }

  document.addEventListener("DOMContentLoaded", function () { wireRail(document); });
  if (document.readyState !== "loading") wireRail(document);
  document.addEventListener("shopify:section:load", function (e) { wireRail(e.target); });
})();
